"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRoles = exports.User = exports.UserData = void 0;
var course_1 = require("./course");
var group_1 = require("./group");
var group_invitation_1 = require("./group_invitation");
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var UserData = /** @class */ (function () {
    function UserData(_a) {
        var pk = _a.pk, username = _a.username, first_name = _a.first_name, last_name = _a.last_name, is_superuser = _a.is_superuser;
        this.pk = pk;
        this.username = username;
        this.first_name = first_name;
        this.last_name = last_name;
        this.is_superuser = is_superuser;
    }
    return UserData;
}());
exports.UserData = UserData;
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    User.get_current = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get('/users/current/')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new User(response.data)];
                }
            });
        });
    };
    User.get_current_user_roles = function (course_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/" + course_pk + "/my_roles/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new UserRoles(response.data)];
                }
            });
        });
    };
    User.current_can_create_courses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get('/users/current/can_create_courses/')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    User.get_by_pk = function (pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new User(response.data)];
                }
            });
        });
    };
    User.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        return [2 /*return*/];
                }
            });
        });
    };
    User.prototype.courses_is_admin_for = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + this.pk + "/courses_is_admin_for/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (course_data) { return new course_1.Course(course_data); })];
                }
            });
        });
    };
    User.prototype.courses_is_staff_for = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + this.pk + "/courses_is_staff_for/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (course_data) { return new course_1.Course(course_data); })];
                }
            });
        });
    };
    User.prototype.courses_is_student_in = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + this.pk + "/courses_is_enrolled_in/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (course_data) { return new course_1.Course(course_data); })];
                }
            });
        });
    };
    User.prototype.courses_is_handgrader_for = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + this.pk + "/courses_is_handgrader_for/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (course_data) { return new course_1.Course(course_data); })];
                }
            });
        });
    };
    User.prototype.groups_is_member_of = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + this.pk + "/groups_is_member_of/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (data) { return new group_1.Group(data); })];
                }
            });
        });
    };
    User.prototype.group_invitations_sent = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + this.pk + "/group_invitations_sent/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (data) { return new group_invitation_1.GroupInvitation(data); })];
                }
            });
        });
    };
    User.prototype.group_invitations_received = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + this.pk + "/group_invitations_received/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (data) { return new group_invitation_1.GroupInvitation(data); })];
                }
            });
        });
    };
    User.get_num_late_days = function (course_pk, username_or_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/users/" + username_or_pk + "/late_days/?course_pk=" + course_pk)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    User.set_num_late_days = function (course_pk, username_or_pk, num_late_days) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/users/" + username_or_pk + "/late_days/?course_pk=" + course_pk, { late_days_remaining: num_late_days })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return User;
}(UserData));
exports.User = User;
var UserRoles = /** @class */ (function () {
    function UserRoles(_a) {
        var is_admin = _a.is_admin, is_staff = _a.is_staff, is_student = _a.is_student, is_handgrader = _a.is_handgrader;
        this.is_admin = is_admin;
        this.is_staff = is_staff;
        this.is_student = is_student;
        this.is_handgrader = is_handgrader;
    }
    return UserRoles;
}());
exports.UserRoles = UserRoles;
//# sourceMappingURL=user.js.map